module.exports = __webpack_public_path__ + "img/home-hero.c8d01ae0.jpg";